/**
 * Display helpers for read-only milestone forecast hints from the PM API.
 */

export function milestoneForecastHintLabelKey(forecastHint) {
  if (forecastHint === 'on_track') return 'UserProjects.milestones.forecastHint.onTrack';
  if (forecastHint === 'at_risk') return 'UserProjects.milestones.forecastHint.atRisk';
  if (forecastHint === 'blocked') return 'UserProjects.milestones.forecastHint.blocked';
  return null;
}

export function milestoneForecastHintSeverity(forecastHint) {
  if (forecastHint === 'on_track') return 'success';
  if (forecastHint === 'at_risk') return 'warn';
  if (forecastHint === 'blocked') return 'danger';
  return 'secondary';
}

export function shouldShowForecastHintBadge(forecastHint, milestoneStatus) {
  if (!forecastHint || forecastHint === 'on_track') return false;
  if (forecastHint === 'at_risk' && milestoneStatus === 'at_risk') return false;
  return true;
}

export function hasSuggestedAtRiskBanner(milestones = []) {
  return milestones.some(
    (item) => item.forecastHint === 'at_risk' || item.forecastHint === 'blocked',
  );
}

export function suggestedAtRiskMilestone(milestones = []) {
  return milestones.find(
    (item) => (item.forecastHint === 'at_risk' || item.forecastHint === 'blocked')
      && item.status !== 'done'
      && item.status !== 'at_risk',
  ) ?? null;
}
